<template>
  <div class="progression-bosses pt-4 mt-5 border-top">
    <h2 class="font-diablo mb-4">Progression</h2>
    <b-row>
      <b-col v-for="(val, key) in sortedActs" :key="key" class="col-12 col-md-2">
        <div class="bg-dark rounded mb-2">
          <ProgressItem :act="{ actNum: key, value: val }" />
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import ProgressItem from './ProgressItem.vue';

export default {
  name: 'ProgressBosses',
  components: { ProgressItem },
  props: {
    acts: {
      required: true,
      type: Object,
    },
  },
  computed: {
    /**
     * Order acts from 1 to 5
     * @returns {Object} Ordered acts
     */
    sortedActs() {
      return Object.keys(this.acts)
        .sort()
        .reduce((a, c) => {
          const newA = a;
          newA[c] = this.acts[c];
          return newA;
        }, {});
    },
  },
};
</script>

<style lang="scss" scope>
.progression-bosses .boss-img {
  display: block;
}
.progression-bosses .boss-img .act {
  margin: 0 auto;
  width: 50px;
  height: 55px;
}
</style>
